import { useTenantSetting } from "@nestoca/multi-tenant";
import { OptionItem } from "@shared/ui";
import { useTranslation } from "react-i18next";

import { PROPERTY_PURPOSE_AFTER_TRANSACTION } from "./property-purpose.const";

const PROPERTY_PURPOSE_LABEL: Record<string, string> = {
  SOLD: "owned-property:sold",
  OWNER_OCCUPIED: "owned-property:ownerOccupied",
  OWNER_OCCUPIED_AND_RENTAL: "owned-property:ownerOccupiedWithRental",
  RENTAL: "owned-property:rental",
  SECONDARY_RESIDENCE: "owned-property:secondaryResidence",
  SeasonalHome: "owned-property:seasonalHome",
  VACANT: "owned-property:vacant",
  OTHER: "owned-property:other",
};

export const useOwnedPropertyAfterTransactionPurposeOptions =
  (): OptionItem[] => {
    const { settings: { ownedPropertyAfterTransactionPurposeTypes } = {} } =
      useTenantSetting("typesOverride");

    const { t } = useTranslation("owned-property");

    if (!ownedPropertyAfterTransactionPurposeTypes) {
      return PROPERTY_PURPOSE_AFTER_TRANSACTION.map((option) => ({
        value: option.value,
        label: t(option.label),
      }));
    }

    return ownedPropertyAfterTransactionPurposeTypes.map((type) => ({
      value: type,
      label: t(PROPERTY_PURPOSE_LABEL[type] ?? type),
    }));
  };
